// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__cgsZU","range":"MonthRangeSwitch_range__y7g3f","disabled":"MonthRangeSwitch_disabled__oeX4i"};